import { useQuery } from '@tanstack/react-query';

import { getBalancerTask, WALLET_BALANCER_QUERY_KEYS } from '../api';
import type { TaskBalancer, TaskBalancerQueryParams } from '../model/types';

export const useBalancerTasks = (params: TaskBalancerQueryParams, enabled = true) => {
  return useQuery<TaskBalancer[]>({
    queryKey: WALLET_BALANCER_QUERY_KEYS.list(params),
    queryFn: async () => {
      const response = await getBalancerTask(params);

      if (!response.isSuccess || !response.data || !Array.isArray(response.data.tasks)) {
        throw new Error(response.errorMessage || 'Failed to fetch balancer tasks');
      }

      return response.data.tasks;
    },
    enabled,
  });
};
